import Vue from "vue";
import store from "./store";
import Router from "vue-router";

// Admin only routes
import adminRoutes from "./router/admin";
import adminContentRoutes from "./router/adminContent";
import adminDocumentsRoutes from "./router/adminDocuments";

// All other routes

import contentRoutes from "./router/content";
import documentsRoutes from "./router/documents";
import systemStatusRoutes from "./router/systemStatus";
import errorRoutes from "./router/errors";

import { NewsRoutes, NewsCategoryRoutes } from "./router/news";
import { EventRoutes } from "./router/events";
import { FilesRoutes } from "./router/Files";
import { CollaborationRoutes } from "./router/collaboration/";
import { UserGroupRoutes } from "./router/UserGroups";
import NotificationRoutes from "./router/Notifications";
import AlertRoutes from "./router/alerts";
import UserRoutes from "./router/users";

import InterestGroupRoutes from "./router/InterestGroups";

import { requireAuth, loggedOut, privilegeCheck } from "./router/helpers";

import FormBuilderRoutes from "./router/FormBuilder";

/**
 * New modules stuff
 */
import { BannerRoutes } from "@/modules/banner/routes";
import { PollRoutes } from "@/modules/polls/routes";
import DeviceNotificationRoutes from "@/modules/deviceNotifications/routes";
import { SurveyRoutes,SurveyCategoryRoutes } from "@/modules/surveys/routes";

Vue.use(Router);

const baseRoutes = [
  {
    path: "/login",
    name: "Login",
    component: () => import("@/views/Login"),
    beforeEnter: loggedOut,
    meta: {
      isGuest: true,
    },
  },
  {
    path: "/logout",
    name: "Logout",
    beforeEnter(to, from, next) {
      if (store.state.auth.token) {
        store.dispatch("auth/logout");
        next({ path: "/login", query: { loggedOut: true } });
      }
    },
  },
  // DASHBOARD
  // ---------
  {
    path: "/",
    redirect: "/dashboard",
  },
  {
    path: "/dashboard",
    name: "Dashboard",
    component: () => import("@/views/Dashboard"),
    beforeEnter: requireAuth,
  },

  // Search
  // ---------
  {
    path: "/search",
    name: "Search",
    component: () => import("@/views/Search"),
    beforeEnter: requireAuth,
  },
];

const routes = baseRoutes.concat(
  adminRoutes,
  adminContentRoutes,
  adminDocumentsRoutes,
  contentRoutes,
  documentsRoutes,
  systemStatusRoutes,
  NewsCategoryRoutes,
  NewsRoutes,
  EventRoutes,
  CollaborationRoutes,
  InterestGroupRoutes,
  UserGroupRoutes,
  FilesRoutes,
  NotificationRoutes,
  AlertRoutes,
  UserRoutes,
  FormBuilderRoutes,
  BannerRoutes,
  DeviceNotificationRoutes,
  SurveyCategoryRoutes,
  SurveyRoutes,
  PollRoutes,
  errorRoutes
);

const router = new Router({
  mode: "history",

  linkActiveClass: "is-active",

  scrollBehavior(to, from, savedPosition) {
    if (store.state.scrollPosition) {
      store.commit("setSrollPosition", false);
      return store.state.scrollPosition;
    }
    return { x: 0, y: 0 };
  },

  routes,
});

/**
 * If we are opening the panel, add a css class to prevent the body from scrolling
 * We also need to do a permissions check if we have any available to us
 */
router.beforeEach((to, from, next) => {
  // are we trying to get to admin and do we have admin disabled?

  if (to.meta.isAdmin && Vue.prototype.$adminDisabled) {
    next("/dashboard");
  }
  /**
   * If the user is only a user, remove them
   * TODO:  Ideally needs to check against all privilege groups
   * Will mean updating all routes meta info with required groups
   * But can then give more granular control over who can access what
   */
  if (to.meta.isAdmin) {
    let filterGroups;
    if (!store.state.auth.currentUser.privilege_groups) {
      store.dispatch("auth/listCurrentUser").then((resp) => {
        filterGroups = Object.keys(resp.privilege_groups).filter(
          (grp) => resp.privilege_groups[grp]
        );
        console.log(
          "🚀 ~ file: router.js ~ line 142 ~ store.dispatch ~ filterGroups",
          filterGroups
        );
        if (filterGroups.length == 1 && filterGroups[0] == "user") {
          next("/unauthorized");
        }
      });
    } else {
      filterGroups = Object.keys(
        store.state.auth.currentUser.privilege_groups
      ).filter((grp) => store.state.auth.currentUser.privilege_groups[grp]);

      if (filterGroups.length == 1 && filterGroups[0] == "user") {
        next("/unauthorized");
      }
    }
  }
  if (to.meta.openPanel) {
    // add a class to the body
    document.querySelector("body").classList.add("noscroll");
    store.dispatch("OPEN_PANEL");
  } else if (document.querySelector("body.noscroll")) {
    document.querySelector("body.noscroll").classList.remove("noscroll");
  }

  if (to.meta.permissions) {
    let privileges;
    if (!store.state.auth.currentUser.privileges) {
      store.dispatch("auth/listCurrentUser").then((resp) => {
        privileges = resp.privileges;
        if (!privilegeCheck(to.meta.permissions, privileges)) {
          next("/unauthorized");
        }
      });
    } else {
      privileges = store.state.auth.currentUser.privileges;
      if (!privilegeCheck(to.meta.permissions, privileges)) {
        next("/unauthorized");
      }
    }
  }

  return next();
});

router.afterEach((to, from) => {
  // after every route, can we hide the menu?  Needed for mobile
  store.dispatch("navigation/closeMenu");
});

export default router;
